// Signing in — the login page, the set-your-password card, Google registration, the reset-password screens,
// the password box's eye and the route guard's loading line — in the portal's four languages (2026-10-21).
// The login page's DRIVER card is NOT here: it is Vietnamese on purpose, for the two drivers, in every language.
const en = {
  errGoogleDomain: 'Please sign in with your Helinox company email ending in @helinox.com. DAC: use the "Sign in with Google" button under the DAC logo. Other partners: use the Helinox Partner card.',
  errGoogleUnverified: 'Google could not verify this email address. Please use a verified Helinox company email.',
  errGoogleDenied: 'Google sign in was cancelled. Please try again.',
  errGoogleInactive: 'This Helinox account is inactive. Please contact an administrator.',
  errAccountPending: 'Your account has been created and is waiting for approval by Helinox. You can sign in once it is approved.',
  errGoogleConfig: 'Google sign in is not configured yet. Please contact an administrator.',
  errGoogleFailed: 'Google sign in failed. Please try again.',
  errPartnerConfig: 'Partner sign-in with Google is not set up yet. Please use your username and password, or ask your HEVN contact.',
  errPartnerDomain: 'This Google account is not a DAC address or another company set up for the HEVN Portal. Helinox staff: use the "Sign in with Google" button at the top.',
  errPartnerOff: "Your company's access to the HEVN Portal is switched off. Please ask your HEVN contact.",
  errPartnerNoAccount: 'There is no portal account for this address yet. Please request access on the Helinox Partner card.',
  invalidLogin: 'Invalid username or password',
  pwMismatch: 'The two passwords do not match.',
  setPwFailed: 'Could not set the password.',
  setPwTitle: 'Set your password',
  setPwSub: 'This account is still on the password it was created with. Choose your own to continue.',
  newPassword: 'New password',
  confirm: 'Confirm',
  confirmPassword: 'Confirm password',
  phAtLeast8: 'At least 8 characters',
  phTypeAgain: 'Type it again',
  pwRuleHint: 'At least 8 characters, with an upper-case letter, a lower-case letter and a number.',
  saving: 'Saving…',
  saveContinue: 'Save and continue',
  helinoxSub: 'Sign in with your Helinox Google account.',
  signInGoogle: 'Sign in with Google',
  community: 'Meet the community',
  socialWeb: 'Helinox website',
  socialIg: 'Helinox on Instagram',
  socialFb: 'Helinox on Facebook',
  partnerTitle: 'Helinox Partner',
  partnerSub: 'Vendors and partners.',
  username: 'Username',
  password: 'Password',
  remember30: 'Remember for 30 days',
  forgotPw: 'Forget password?',
  noAccount: 'No account yet?',
  requestAccess: 'Request access',
  signingIn: 'Signing In...',
  signIn: 'Sign In',
  // Google registration
  regSessionExpired: 'Your Google verification session has expired. Please sign in with Google again.',
  valUsername: 'Username must be between 3 and 50 characters.',
  valFirstName: 'First name must be between 2 and 50 characters.',
  valLastName: 'Last name must be between 2 and 50 characters.',
  valPwLength: 'Password must be at least 8 characters long.',
  valPwMix: 'Password must contain at least one uppercase letter, one lowercase letter, and one number.',
  valPwMatch: 'Passwords do not match.',
  regFailed: 'Unable to create your account. Please try again.',
  googleVerified: 'Google verified',
  createAccount: 'Create Account',
  checkingGoogle: 'Checking your Google verification...',
  firstName: 'First Name',
  firstNamePh: 'First name',
  lastName: 'Last Name',
  lastNamePh: 'Last name',
  creating: 'Creating...',
  backToSignIn: 'Back to sign in',
  // Choosing a password from the mailed link
  valAllFields: 'All fields must be filled in.',
  errorOccurred: 'An error occurred',
  linkIncomplete: 'That link is incomplete',
  linkIncompleteSub: 'Open the link from your email again, or ask for a new one.',
  sendNewLink: 'Send me a new link',
  choosePwTitle: 'Choose your password',
  takingYou: 'Taking you to sign in…',
  goNow: 'go now',
  savePassword: 'Save password',
  // Asking for the link
  forgotTitle: 'Forgot Password?',
  forgotGuide: 'Enter your username to receive a reset password email:',
  sending: 'SENDING...',
  sendResetLink: 'SEND RESET PASSWORD LINK',
  logoAlt: 'Logo',
  // The password box's eye
  show: 'Show',
  hide: 'Hide',
  showWhat: 'Show {{what}}',
  hideWhat: 'Hide {{what}}',
  whatPassword: 'password',
  whatNewPassword: 'new password',
  whatConfirmation: 'the confirmation',
  // The route guard
  loading: 'Loading...',
};

const ko = {
  errGoogleDomain: '@helinox.com으로 끝나는 Helinox 회사 이메일로 로그인하세요. DAC: DAC 로고 아래의 "Google로 로그인" 버튼을 사용하세요. 기타 파트너: Helinox 파트너 카드를 사용하세요.',
  errGoogleUnverified: 'Google에서 이 이메일 주소를 확인할 수 없습니다. 인증된 Helinox 회사 이메일을 사용하세요.',
  errGoogleDenied: 'Google 로그인이 취소되었습니다. 다시 시도하세요.',
  errGoogleInactive: '이 Helinox 계정은 비활성 상태입니다. 관리자에게 문의하세요.',
  errAccountPending: '계정이 만들어졌으며 Helinox의 승인을 기다리고 있습니다. 승인되면 로그인할 수 있습니다.',
  errGoogleConfig: 'Google 로그인이 아직 설정되지 않았습니다. 관리자에게 문의하세요.',
  errGoogleFailed: 'Google 로그인에 실패했습니다. 다시 시도하세요.',
  errPartnerConfig: '파트너용 Google 로그인이 아직 설정되지 않았습니다. 아이디와 비밀번호를 사용하거나 HEVN 담당자에게 문의하세요.',
  errPartnerDomain: '이 Google 계정은 DAC 주소도, HEVN Portal에 등록된 다른 회사의 주소도 아닙니다. Helinox 직원: 위쪽의 "Google로 로그인" 버튼을 사용하세요.',
  errPartnerOff: '귀사의 HEVN Portal 접근이 해제되어 있습니다. HEVN 담당자에게 문의하세요.',
  errPartnerNoAccount: '이 주소로 된 포털 계정이 아직 없습니다. Helinox 파트너 카드에서 접근 권한을 요청하세요.',
  invalidLogin: '아이디 또는 비밀번호가 올바르지 않습니다',
  pwMismatch: '두 비밀번호가 일치하지 않습니다.',
  setPwFailed: '비밀번호를 설정하지 못했습니다.',
  setPwTitle: '비밀번호 설정',
  setPwSub: '이 계정은 아직 생성 시의 비밀번호를 사용하고 있습니다. 계속하려면 본인의 비밀번호를 정하세요.',
  newPassword: '새 비밀번호',
  confirm: '확인',
  confirmPassword: '비밀번호 확인',
  phAtLeast8: '8자 이상',
  phTypeAgain: '한 번 더 입력',
  pwRuleHint: '8자 이상, 대문자·소문자·숫자를 각각 하나 이상 포함해야 합니다.',
  saving: '저장 중…',
  saveContinue: '저장하고 계속',
  helinoxSub: 'Helinox Google 계정으로 로그인하세요.',
  signInGoogle: 'Google로 로그인',
  community: '커뮤니티 만나기',
  socialWeb: 'Helinox 웹사이트',
  socialIg: 'Helinox 인스타그램',
  socialFb: 'Helinox 페이스북',
  partnerTitle: 'Helinox 파트너',
  partnerSub: '공급업체 및 파트너.',
  username: '아이디',
  password: '비밀번호',
  remember30: '30일 동안 로그인 유지',
  forgotPw: '비밀번호를 잊으셨나요?',
  noAccount: '아직 계정이 없나요?',
  requestAccess: '접근 요청',
  signingIn: '로그인 중...',
  signIn: '로그인',
  regSessionExpired: 'Google 인증 세션이 만료되었습니다. Google로 다시 로그인하세요.',
  valUsername: '아이디는 3~50자여야 합니다.',
  valFirstName: '이름은 2~50자여야 합니다.',
  valLastName: '성은 2~50자여야 합니다.',
  valPwLength: '비밀번호는 8자 이상이어야 합니다.',
  valPwMix: '비밀번호에는 대문자, 소문자, 숫자가 각각 하나 이상 있어야 합니다.',
  valPwMatch: '비밀번호가 일치하지 않습니다.',
  regFailed: '계정을 만들 수 없습니다. 다시 시도하세요.',
  googleVerified: 'Google 인증 완료',
  createAccount: '계정 만들기',
  checkingGoogle: 'Google 인증을 확인하는 중...',
  firstName: '이름',
  firstNamePh: '이름',
  lastName: '성',
  lastNamePh: '성',
  creating: '만드는 중...',
  backToSignIn: '로그인으로 돌아가기',
  valAllFields: '모든 항목을 입력해야 합니다.',
  errorOccurred: '오류가 발생했습니다',
  linkIncomplete: '링크가 완전하지 않습니다',
  linkIncompleteSub: '이메일의 링크를 다시 열거나 새 링크를 요청하세요.',
  sendNewLink: '새 링크 보내기',
  choosePwTitle: '비밀번호 정하기',
  takingYou: '로그인 화면으로 이동합니다…',
  goNow: '바로 가기',
  savePassword: '비밀번호 저장',
  forgotTitle: '비밀번호를 잊으셨나요?',
  forgotGuide: '비밀번호 재설정 메일을 받으려면 아이디를 입력하세요:',
  sending: '보내는 중...',
  sendResetLink: '비밀번호 재설정 링크 보내기',
  logoAlt: '로고',
  show: '보기',
  hide: '숨기기',
  showWhat: '{{what}} 보기',
  hideWhat: '{{what}} 숨기기',
  whatPassword: '비밀번호',
  whatNewPassword: '새 비밀번호',
  whatConfirmation: '확인 비밀번호',
  loading: '불러오는 중...',
};

const vi = {
  errGoogleDomain: 'Vui lòng đăng nhập bằng email công ty Helinox có đuôi @helinox.com. DAC: dùng nút "Đăng nhập bằng Google" dưới logo DAC. Đối tác khác: dùng thẻ Đối tác Helinox.',
  errGoogleUnverified: 'Google không xác minh được địa chỉ email này. Vui lòng dùng email công ty Helinox đã được xác minh.',
  errGoogleDenied: 'Đã hủy đăng nhập Google. Vui lòng thử lại.',
  errGoogleInactive: 'Tài khoản Helinox này đang bị vô hiệu hóa. Vui lòng liên hệ quản trị viên.',
  errAccountPending: 'Tài khoản của anh chị đã được tạo và đang chờ Helinox duyệt. Anh chị đăng nhập được sau khi tài khoản được duyệt.',
  errGoogleConfig: 'Đăng nhập Google chưa được thiết lập. Vui lòng liên hệ quản trị viên.',
  errGoogleFailed: 'Đăng nhập Google không thành công. Vui lòng thử lại.',
  errPartnerConfig: 'Đăng nhập Google cho đối tác chưa được thiết lập. Vui lòng dùng tên đăng nhập và mật khẩu, hoặc hỏi người liên hệ bên HEVN.',
  errPartnerDomain: 'Tài khoản Google này không phải địa chỉ DAC hay của một công ty khác đã được thiết lập cho HEVN Portal. Nhân viên Helinox: dùng nút "Đăng nhập bằng Google" ở trên cùng.',
  errPartnerOff: 'Quyền truy cập HEVN Portal của công ty bạn đang bị tắt. Vui lòng hỏi người liên hệ bên HEVN.',
  errPartnerNoAccount: 'Chưa có tài khoản portal cho địa chỉ này. Vui lòng yêu cầu quyền truy cập ở thẻ Đối tác Helinox.',
  invalidLogin: 'Sai tên đăng nhập hoặc mật khẩu',
  pwMismatch: 'Hai mật khẩu không khớp.',
  setPwFailed: 'Không đặt được mật khẩu.',
  setPwTitle: 'Đặt mật khẩu của bạn',
  setPwSub: 'Tài khoản này vẫn đang dùng mật khẩu lúc tạo. Hãy chọn mật khẩu riêng để tiếp tục.',
  newPassword: 'Mật khẩu mới',
  confirm: 'Nhập lại',
  confirmPassword: 'Nhập lại mật khẩu',
  phAtLeast8: 'Ít nhất 8 ký tự',
  phTypeAgain: 'Nhập lại lần nữa',
  pwRuleHint: 'Ít nhất 8 ký tự, có chữ hoa, chữ thường và chữ số.',
  saving: 'Đang lưu…',
  saveContinue: 'Lưu và tiếp tục',
  helinoxSub: 'Đăng nhập bằng tài khoản Google Helinox của bạn.',
  signInGoogle: 'Đăng nhập bằng Google',
  community: 'Gặp gỡ cộng đồng',
  socialWeb: 'Website Helinox',
  socialIg: 'Helinox trên Instagram',
  socialFb: 'Helinox trên Facebook',
  partnerTitle: 'Đối tác Helinox',
  partnerSub: 'Nhà cung cấp và đối tác.',
  username: 'Tên đăng nhập',
  password: 'Mật khẩu',
  remember30: 'Ghi nhớ trong 30 ngày',
  forgotPw: 'Quên mật khẩu?',
  noAccount: 'Chưa có tài khoản?',
  requestAccess: 'Yêu cầu truy cập',
  signingIn: 'Đang đăng nhập...',
  signIn: 'Đăng nhập',
  regSessionExpired: 'Phiên xác minh Google đã hết hạn. Vui lòng đăng nhập lại bằng Google.',
  valUsername: 'Tên đăng nhập phải từ 3 đến 50 ký tự.',
  valFirstName: 'Tên phải từ 2 đến 50 ký tự.',
  valLastName: 'Họ phải từ 2 đến 50 ký tự.',
  valPwLength: 'Mật khẩu phải có ít nhất 8 ký tự.',
  valPwMix: 'Mật khẩu phải có ít nhất một chữ hoa, một chữ thường và một chữ số.',
  valPwMatch: 'Mật khẩu không khớp.',
  regFailed: 'Không tạo được tài khoản. Vui lòng thử lại.',
  googleVerified: 'Đã xác minh Google',
  createAccount: 'Tạo tài khoản',
  checkingGoogle: 'Đang kiểm tra xác minh Google...',
  firstName: 'Tên',
  firstNamePh: 'Tên',
  lastName: 'Họ',
  lastNamePh: 'Họ',
  creating: 'Đang tạo...',
  backToSignIn: 'Quay lại đăng nhập',
  valAllFields: 'Phải điền đầy đủ tất cả các ô.',
  errorOccurred: 'Đã xảy ra lỗi',
  linkIncomplete: 'Đường link này không đầy đủ',
  linkIncompleteSub: 'Hãy mở lại link trong email, hoặc yêu cầu link mới.',
  sendNewLink: 'Gửi cho tôi link mới',
  choosePwTitle: 'Chọn mật khẩu của bạn',
  takingYou: 'Đang chuyển đến trang đăng nhập…',
  goNow: 'đi ngay',
  savePassword: 'Lưu mật khẩu',
  forgotTitle: 'Quên mật khẩu?',
  forgotGuide: 'Nhập tên đăng nhập để nhận email đặt lại mật khẩu:',
  sending: 'ĐANG GỬI...',
  sendResetLink: 'GỬI LINK ĐẶT LẠI MẬT KHẨU',
  logoAlt: 'Logo',
  show: 'Hiện',
  hide: 'Ẩn',
  showWhat: 'Hiện {{what}}',
  hideWhat: 'Ẩn {{what}}',
  whatPassword: 'mật khẩu',
  whatNewPassword: 'mật khẩu mới',
  whatConfirmation: 'mật khẩu nhập lại',
  loading: 'Đang tải...',
};

const zh = {
  errGoogleDomain: '请使用以 @helinox.com 结尾的 Helinox 公司邮箱登录。DAC：请使用 DAC 标志下方的“使用 Google 登录”按钮。其他合作伙伴：请使用 Helinox 合作伙伴卡片。',
  errGoogleUnverified: 'Google 无法验证此邮箱地址。请使用已验证的 Helinox 公司邮箱。',
  errGoogleDenied: 'Google 登录已取消。请重试。',
  errGoogleInactive: '此 Helinox 账户已停用。请联系管理员。',
  errAccountPending: '您的账户已创建，正在等待 Helinox 批准。批准后即可登录。',
  errGoogleConfig: 'Google 登录尚未配置。请联系管理员。',
  errGoogleFailed: 'Google 登录失败。请重试。',
  errPartnerConfig: '合作伙伴的 Google 登录尚未设置。请使用用户名和密码，或联系您的 HEVN 对接人。',
  errPartnerDomain: '此 Google 账户既不是 DAC 地址，也不属于已为 HEVN Portal 设置的其他公司。Helinox 员工：请使用顶部的“使用 Google 登录”按钮。',
  errPartnerOff: '贵公司对 HEVN Portal 的访问已关闭。请联系您的 HEVN 对接人。',
  errPartnerNoAccount: '此地址尚无门户账户。请在 Helinox 合作伙伴卡片上申请访问权限。',
  invalidLogin: '用户名或密码错误',
  pwMismatch: '两次输入的密码不一致。',
  setPwFailed: '无法设置密码。',
  setPwTitle: '设置您的密码',
  setPwSub: '此账户仍在使用创建时的密码。请设置您自己的密码以继续。',
  newPassword: '新密码',
  confirm: '确认',
  confirmPassword: '确认密码',
  phAtLeast8: '至少 8 个字符',
  phTypeAgain: '再输入一次',
  pwRuleHint: '至少 8 个字符，包含大写字母、小写字母和数字。',
  saving: '正在保存…',
  saveContinue: '保存并继续',
  helinoxSub: '使用您的 Helinox Google 账户登录。',
  signInGoogle: '使用 Google 登录',
  community: '加入社区',
  socialWeb: 'Helinox 官网',
  socialIg: 'Helinox 的 Instagram',
  socialFb: 'Helinox 的 Facebook',
  partnerTitle: 'Helinox 合作伙伴',
  partnerSub: '供应商和合作伙伴。',
  username: '用户名',
  password: '密码',
  remember30: '30 天内保持登录',
  forgotPw: '忘记密码？',
  noAccount: '还没有账户？',
  requestAccess: '申请访问',
  signingIn: '正在登录...',
  signIn: '登录',
  regSessionExpired: '您的 Google 验证会话已过期。请重新使用 Google 登录。',
  valUsername: '用户名须为 3 到 50 个字符。',
  valFirstName: '名字须为 2 到 50 个字符。',
  valLastName: '姓氏须为 2 到 50 个字符。',
  valPwLength: '密码至少须为 8 个字符。',
  valPwMix: '密码须至少包含一个大写字母、一个小写字母和一个数字。',
  valPwMatch: '密码不一致。',
  regFailed: '无法创建您的账户。请重试。',
  googleVerified: 'Google 已验证',
  createAccount: '创建账户',
  checkingGoogle: '正在检查您的 Google 验证...',
  firstName: '名字',
  firstNamePh: '名字',
  lastName: '姓氏',
  lastNamePh: '姓氏',
  creating: '正在创建...',
  backToSignIn: '返回登录',
  valAllFields: '所有字段都必须填写。',
  errorOccurred: '发生错误',
  linkIncomplete: '该链接不完整',
  linkIncompleteSub: '请重新打开邮件中的链接，或申请新的链接。',
  sendNewLink: '给我发送新链接',
  choosePwTitle: '选择您的密码',
  takingYou: '正在前往登录…',
  goNow: '立即前往',
  savePassword: '保存密码',
  forgotTitle: '忘记密码？',
  forgotGuide: '输入您的用户名以接收重置密码邮件：',
  sending: '正在发送...',
  sendResetLink: '发送重置密码链接',
  logoAlt: '标志',
  show: '显示',
  hide: '隐藏',
  showWhat: '显示{{what}}',
  hideWhat: '隐藏{{what}}',
  whatPassword: '密码',
  whatNewPassword: '新密码',
  whatConfirmation: '确认密码',
  loading: '加载中...',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "errGoogleDomain": "Veuillez vous connecter avec votre adresse e-mail Helinox se terminant par @helinox.com. DAC : utilisez le bouton « Se connecter avec Google » sous le logo DAC. Autres partenaires : utilisez la carte Helinox Partner.",
  "errGoogleUnverified": "Google n'a pas pu vérifier cette adresse e-mail. Veuillez utiliser une adresse e-mail Helinox vérifiée.",
  "errGoogleDenied": "La connexion avec Google a été annulée. Veuillez réessayer.",
  "errGoogleInactive": "Ce compte Helinox est inactif. Veuillez contacter un administrateur.",
  "errAccountPending": "Votre compte a été créé et attend l'approbation de Helinox. Vous pourrez vous connecter une fois celle-ci accordée.",
  "errGoogleConfig": "La connexion avec Google n'est pas encore configurée. Veuillez contacter un administrateur.",
  "errGoogleFailed": "La connexion avec Google a échoué. Veuillez réessayer.",
  "errPartnerConfig": "La connexion partenaire avec Google n'est pas encore configurée. Veuillez utiliser votre identifiant et votre mot de passe, ou contacter votre interlocuteur HEVN.",
  "errPartnerDomain": "Ce compte Google n'est ni une adresse DAC ni celle d'une autre société configurée pour le HEVN Portal. Personnel Helinox : utilisez le bouton « Se connecter avec Google » en haut.",
  "errPartnerOff": "L'accès de votre société au HEVN Portal est désactivé. Veuillez contacter votre interlocuteur HEVN.",
  "errPartnerNoAccount": "Aucun compte du portail n'existe encore pour cette adresse. Veuillez demander un accès sur la carte Helinox Partner.",
  "invalidLogin": "Identifiant ou mot de passe incorrect",
  "pwMismatch": "Les deux mots de passe ne correspondent pas.",
  "setPwFailed": "Impossible de définir le mot de passe.",
  "setPwTitle": "Définir votre mot de passe",
  "setPwSub": "Ce compte utilise encore le mot de passe fourni à sa création. Choisissez le vôtre pour continuer.",
  "newPassword": "Nouveau mot de passe",
  "confirm": "Confirmer",
  "confirmPassword": "Confirmer le mot de passe",
  "phAtLeast8": "Au moins 8 caractères",
  "phTypeAgain": "Saisissez-le à nouveau",
  "pwRuleHint": "Au moins 8 caractères, avec une majuscule, une minuscule et un chiffre.",
  "saving": "Enregistrement…",
  "saveContinue": "Enregistrer et continuer",
  "helinoxSub": "Connectez-vous avec votre compte Google Helinox.",
  "signInGoogle": "Se connecter avec Google",
  "community": "Rejoindre la communauté",
  "socialWeb": "Site web Helinox",
  "socialIg": "Helinox sur Instagram",
  "socialFb": "Helinox sur Facebook",
  "partnerTitle": "Partenaire Helinox",
  "partnerSub": "Fournisseurs et partenaires.",
  "username": "Identifiant",
  "password": "Mot de passe",
  "remember30": "Se souvenir pendant 30 jours",
  "forgotPw": "Mot de passe oublié ?",
  "noAccount": "Pas encore de compte ?",
  "requestAccess": "Demander un accès",
  "signingIn": "Connexion en cours...",
  "signIn": "Se connecter",
  "regSessionExpired": "Votre session de vérification Google a expiré. Veuillez vous connecter à nouveau avec Google.",
  "valUsername": "L'identifiant doit comporter entre 3 et 50 caractères.",
  "valFirstName": "Le prénom doit comporter entre 2 et 50 caractères.",
  "valLastName": "Le nom doit comporter entre 2 et 50 caractères.",
  "valPwLength": "Le mot de passe doit comporter au moins 8 caractères.",
  "valPwMix": "Le mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre.",
  "valPwMatch": "Les mots de passe ne correspondent pas.",
  "regFailed": "Impossible de créer votre compte. Veuillez réessayer.",
  "googleVerified": "Vérifié par Google",
  "createAccount": "Créer le compte",
  "checkingGoogle": "Vérification Google en cours...",
  "firstName": "Prénom",
  "firstNamePh": "Prénom",
  "lastName": "Nom",
  "lastNamePh": "Nom",
  "creating": "Création...",
  "backToSignIn": "Retour à la connexion",
  "valAllFields": "Tous les champs doivent être renseignés.",
  "errorOccurred": "Une erreur s'est produite",
  "linkIncomplete": "Ce lien est incomplet",
  "linkIncompleteSub": "Rouvrez le lien reçu par e-mail, ou demandez-en un nouveau.",
  "sendNewLink": "Envoyez-moi un nouveau lien",
  "choosePwTitle": "Choisissez votre mot de passe",
  "takingYou": "Redirection vers la connexion…",
  "goNow": "y aller maintenant",
  "savePassword": "Enregistrer le mot de passe",
  "forgotTitle": "Mot de passe oublié ?",
  "forgotGuide": "Saisissez votre identifiant pour recevoir un e-mail de réinitialisation du mot de passe :",
  "sending": "ENVOI...",
  "sendResetLink": "ENVOYER LE LIEN DE RÉINITIALISATION",
  "logoAlt": "Logo",
  "show": "Afficher",
  "hide": "Masquer",
  "showWhat": "Afficher {{what}}",
  "hideWhat": "Masquer {{what}}",
  "whatPassword": "le mot de passe",
  "whatNewPassword": "le nouveau mot de passe",
  "whatConfirmation": "la confirmation",
  "loading": "Chargement..."
};
const ja = {
  "errGoogleDomain": "@helinox.com で終わる Helinox の会社メールアドレスでサインインしてください。DAC：DAC ロゴの下の「Google でサインイン」ボタンを使用してください。その他のパートナー：Helinox Partner カードを使用してください。",
  "errGoogleUnverified": "Google がこのメールアドレスを確認できませんでした。確認済みの Helinox の会社メールアドレスを使用してください。",
  "errGoogleDenied": "Google でのサインインがキャンセルされました。もう一度お試しください。",
  "errGoogleInactive": "この Helinox アカウントは無効です。管理者にお問い合わせください。",
  "errAccountPending": "アカウントは作成され、Helinox の承認待ちです。承認されるとサインインできます。",
  "errGoogleConfig": "Google でのサインインはまだ設定されていません。管理者にお問い合わせください。",
  "errGoogleFailed": "Google でのサインインに失敗しました。もう一度お試しください。",
  "errPartnerConfig": "Google によるパートナーのサインインはまだ設定されていません。ユーザー名とパスワードを使用するか、HEVN の担当者にお問い合わせください。",
  "errPartnerDomain": "この Google アカウントは、DAC のアドレスでも、HEVN Portal 用に設定された他社のアドレスでもありません。Helinox の社員は、上部の「Google でサインイン」ボタンを使用してください。",
  "errPartnerOff": "お客様の会社の HEVN Portal へのアクセスは無効になっています。HEVN の担当者にお問い合わせください。",
  "errPartnerNoAccount": "このアドレスに対応するポータルのアカウントはまだありません。Helinox Partner カードでアクセスを申請してください。",
  "invalidLogin": "ユーザー名またはパスワードが正しくありません",
  "pwMismatch": "2 つのパスワードが一致しません。",
  "setPwFailed": "パスワードを設定できませんでした。",
  "setPwTitle": "パスワードを設定",
  "setPwSub": "このアカウントは、作成時のパスワードのままです。続行するにはご自身のパスワードを設定してください。",
  "newPassword": "新しいパスワード",
  "confirm": "確認",
  "confirmPassword": "パスワードの確認",
  "phAtLeast8": "8 文字以上",
  "phTypeAgain": "もう一度入力してください",
  "pwRuleHint": "8 文字以上で、大文字、小文字、数字を含めてください。",
  "saving": "保存中…",
  "saveContinue": "保存して続行",
  "helinoxSub": "Helinox の Google アカウントでサインインしてください。",
  "signInGoogle": "Google でサインイン",
  "community": "コミュニティに参加",
  "socialWeb": "Helinox ウェブサイト",
  "socialIg": "Helinox Instagram",
  "socialFb": "Helinox Facebook",
  "partnerTitle": "Helinoxパートナー",
  "partnerSub": "仕入先およびパートナー向け。",
  "username": "ユーザー名",
  "password": "パスワード",
  "remember30": "30 日間保持する",
  "forgotPw": "パスワードをお忘れですか？",
  "noAccount": "アカウントをお持ちでないですか？",
  "requestAccess": "アクセス申請",
  "signingIn": "サインイン中...",
  "signIn": "サインイン",
  "regSessionExpired": "Google の確認セッションの有効期限が切れました。もう一度 Google でサインインしてください。",
  "valUsername": "ユーザー名は 3～50 文字で入力してください。",
  "valFirstName": "名は 2～50 文字で入力してください。",
  "valLastName": "姓は 2～50 文字で入力してください。",
  "valPwLength": "パスワードは 8 文字以上で入力してください。",
  "valPwMix": "パスワードには大文字、小文字、数字をそれぞれ 1 文字以上含めてください。",
  "valPwMatch": "パスワードが一致しません。",
  "regFailed": "アカウントを作成できませんでした。もう一度お試しください。",
  "googleVerified": "Google 確認済み",
  "createAccount": "アカウントを作成",
  "checkingGoogle": "Google の確認を行っています...",
  "firstName": "名",
  "firstNamePh": "名",
  "lastName": "姓",
  "lastNamePh": "姓",
  "creating": "作成中...",
  "backToSignIn": "サインインに戻る",
  "valAllFields": "すべての項目を入力してください。",
  "errorOccurred": "エラーが発生しました",
  "linkIncomplete": "このリンクは不完全です",
  "linkIncompleteSub": "メールのリンクをもう一度開くか、新しいリンクを依頼してください。",
  "sendNewLink": "新しいリンクを送信",
  "choosePwTitle": "パスワードを設定",
  "takingYou": "サインイン画面に移動します…",
  "goNow": "今すぐ移動",
  "savePassword": "パスワードを保存",
  "forgotTitle": "パスワードをお忘れですか？",
  "forgotGuide": "パスワードリセット用のメールを受け取るため、ユーザー名を入力してください：",
  "sending": "送信中...",
  "sendResetLink": "パスワードリセットリンクを送信",
  "logoAlt": "ロゴ",
  "show": "表示",
  "hide": "非表示",
  "showWhat": "{{what}}を表示",
  "hideWhat": "{{what}}を非表示",
  "whatPassword": "パスワード",
  "whatNewPassword": "新しいパスワード",
  "whatConfirmation": "確認用パスワード",
  "loading": "読み込み中..."
};

const dictionary = { ns: 'xAuth', en, ko, vi, zh, fr, ja };

export default dictionary;
